module.exports = __webpack_public_path__ + "static/media/Icons_stats_rounded.3e83b280.svg";